import { Box, Typography } from '@mui/material';
import React, { useMemo, useState } from 'react';
import ListItem from './ListItem';
import SearchBar from '../../../Components/Ui/SearchBar';
import FilterBar from '../../../Components/Ui/FilterBar';
import { useDispatch, useSelector } from 'react-redux';
import { setYear, setQuarter } from '../../../Reducer/SearchReducer';

// 최근 10년(현재년도 포함)
const YearList = Array.from({ length: 10 }, (_, idx) => {
  const y = new Date().getFullYear() - idx;
  return { value: String(y), label: `${y}년` };
});
const QuarterList = [
  { value: '1', label: '1분기' },
  { value: '2', label: '2분기' },
  { value: '3', label: '3분기' },
  { value: '4', label: '4분기' },
];

export default function MeetingList(props) {
  const tabValue = props.tabValue ?? 0;

  const dispatch = useDispatch();
  const searchInfo = useSelector((state) => state.searchInfo);

  const year = searchInfo.year;
  const quarter = searchInfo.quater;

  const [searchKeyword, setSearchKeyword] = useState('');


  const yearOptions = YearList.map((y) => ({
    value: y.value,
    label: y.label
  }));
  const quarterOptions = QuarterList.map((q) => ({
    value: q.value,
    label: q.label
  }));

  const filterItems = useMemo(() => {
    if (tabValue === 0) {
      return [{ key: 'year', label: '연도', value: year }];
    } else {
      return [
        { key: 'year', label: '연도', value: year },
        { key: 'quarter', label: '분기', value: `${quarter}분기` },
      ];
    }
  }, [tabValue, year, quarter]);

  const filterOptionsByKey = useMemo(
    () => ({
      year: yearOptions,
      quarter: quarterOptions,
    }), [yearOptions, quarterOptions]);

  const filteredMeetingList =
    props.rowData?.filter((item) => {
      const kw = searchKeyword.trim().toLowerCase();

      return tabValue === 0
        ? item.proceedingsYear == year && item.proceedingsTitle.toLowerCase().includes(kw)
        : item.proceedingsYear == year && item.quarterlyOrder == quarter && item.proceedingsTitle.toLowerCase().includes(kw)
    });

  const HandleSearchChange = (e) => {
    setSearchKeyword(e.target.value);
  };

  const HandleFilterSelect = (key, option) => {
    if (key === 'year') {
      dispatch(setYear(option.value));
    } else if (key === 'quarter') {
      dispatch(setQuarter(option.value));
    }
  };

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* 검색, 필터 영역 - 고정 */}
      <SearchBar
        value={searchKeyword}
        onChange={HandleSearchChange}
        placeholder="회의제목 검색"
      />

      <FilterBar
        items={filterItems}
        optionsByKey={filterOptionsByKey}
        onSelect={HandleFilterSelect}
      />

      {/* 회의록 리스트 영역 - 스크롤 */}
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
        {filteredMeetingList && filteredMeetingList.length > 0 ? (
          filteredMeetingList?.map((item, index) => (
            <ListItem key={index} item={item} />
          ))
        ) : (
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              p: 3,
            }}
          >
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
              등록된 회의록이 없습니다.
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}
